import { isIOS } from './device';

interface ElementWithBrowserPrefixes extends Element {
  webkitRequestFullScreen: () => Promise<void>;
  msRequestFullScreen: () => Promise<void>;
  mozRequestFullScreen: () => Promise<void>;
  exitFullscreen: () => Promise<void>;
  webkitExitFullscreen: () => Promise<void>;
  msExitFullscreen: () => Promise<void>;
  mozCancelFullScreen: () => Promise<void>;
}

export const focus = (element: HTMLInputElement) => {
  if (!isIOS()) element.focus();
};

export const togglePageLock = (shouldLock = true) => {
  // TODO: add this to decorator for further features
  if (typeof window === 'undefined') return;

  const method = shouldLock ? 'add' : 'remove';

  const { body } = document;
  body.classList[method]('body--locked');

  const header = document.querySelector('.header');
  if (header) {
    header.classList[method]('header--sticky');
  }
};

function isTargetNumber(target: string | number | HTMLElement): target is number {
  return Object.prototype.toString.call(target) === '[object Number]';
}

function isTargetElement(target: string | number | HTMLElement): target is HTMLElement {
  return typeof target === 'string' || typeof target === 'number' ? false : target.nodeType === 1;
}

export const scrollToElement = (container: HTMLElement, target: string | number | HTMLElement) => {
  let offset = 0;

  if (isTargetElement(target)) {
    offset = target.offsetTop;
  } else if (isTargetNumber(target)) {
    offset = target;
  } else if (target === 'bottom') {
    offset = container.scrollHeight - container.offsetHeight;
  } else if (target === 'top') {
    offset = 0;
  }

  container.scrollTop = offset;
};

export const isVisibleInView = (container: HTMLElement, target: HTMLElement, partial = false) => {
  // Get container properties
  const cTop = container.scrollTop;
  const cBottom = cTop + container.clientHeight;

  // Get element properties
  const eTop = target.offsetTop;
  const eBottom = eTop + target.clientHeight;

  // Check if in view
  const isTotal = eTop >= cTop && eBottom <= cBottom;
  const isPartial = partial && ((eTop < cTop && eBottom > cTop) || (eBottom > cBottom && eTop < cBottom));

  // Return outcome
  return isTotal || isPartial;
};

export const toggleFullscreen = (element: ElementWithBrowserPrefixes) => {
  const { fullscreenElement } = document;
  const {
    requestFullscreen,
    webkitRequestFullScreen,
    msRequestFullScreen,
    mozRequestFullScreen,
    exitFullscreen,
    webkitExitFullscreen,
    msExitFullscreen,
    mozCancelFullScreen,
  } = element;

  if (fullscreenElement) {
    (exitFullscreen || webkitExitFullscreen || msExitFullscreen || mozCancelFullScreen).call(element);
  } else {
    (requestFullscreen || webkitRequestFullScreen || msRequestFullScreen || mozRequestFullScreen).call(element);
  }
};

export const scrollToHTMLElement = (element: HTMLElement) => {
  try {
    let headerHeight = 0;
    const headerElement = document.querySelector('.header');

    if (headerElement) {
      headerHeight = headerElement.getBoundingClientRect().height + 10;
    }

    const y = element.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({ top: y, behavior: 'smooth' });
  } catch (e) {}
};
